// Styles for SuitesCard go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledSuitesCard = styled.div`
  width: 100%;
  @media only ${baseVariables.mediaQuery.md} {
    width: unset;
  }

  .card-chevron {
    position: relative;
    display: block;
    &:before {
      position: absolute;
      right: ${toRem(24)};
      bottom: ${toRem(24)};
      z-index: 1;
      color: ${baseVariables.color.base20};
      [dir='rtl'] & {
        right: unset;
        left: ${toRem(24)};
      }
    }
  }

  .suites-card-container {
    position: relative;
  }

  .suites-image {
    width: 100%;
    @media only ${baseVariables.mediaQuery.md} {
      width: unset;
      height: ${toRem(343)};
    }
    @media only ${baseVariables.mediaQuery.lg} {
      height: ${toRem(364)};
    }
    aspect-ratio: 1/1;
    object-fit: cover;
  }

  .suites-card-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: end;
    justify-content: flex-end;
    width: 100%;
  }

  .card-text-wrapper {
    background: ${baseVariables.gradient['baseGradient05']};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .center-left {
    [dir='rtl'] & {
      justify-content: right;
    }
  }
`;
